'use client';

import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cartelix-cookies');
    if (!accepted) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cartelix-cookies', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cartelix-cookies', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-start gap-3 flex-1">
          <span className="text-xl flex-shrink-0">🍪</span>
          <p style={{ fontSize: '13.5px', color: '#374151', lineHeight: 1.6 }}>
            We use essential cookies to ensure our website functions correctly, and optional analytics cookies to improve your experience.
            By clicking &ldquo;Accept All&rdquo;, you consent to our use of cookies as described in our{' '}
            <span style={{ color: '#1F3A8A', fontWeight: 600, cursor: 'pointer' }}>Privacy Policy</span>.
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={decline}
            className="btn-outline"
            style={{ padding: '9px 18px', fontSize: '13px' }}
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="btn-primary"
            style={{ padding: '10px 20px', fontSize: '13px' }}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}